var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOdAnalysis(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.375 21.6251V2.3501H21.65V21.6251H2.375ZM4.725 19.2751H19.275V4.7251H4.725V19.2751ZM7.225 17.0751H8.725V11.9501H7.225V17.0751ZM15.3 17.0751H16.8V6.5751H15.3V17.0751ZM11.25 17.0751H12.75V14.1251H11.25V17.0751ZM11.25 11.9501H12.75V10.4501H11.25V11.9501ZM4.725 19.2751V4.7251V19.2751Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOdAnalysis);
export default __webpack_public_path__ + "static/media/OD_Analysis.854d44d6ab762962d1b5a39be3d7ba14.svg";
export { ForwardRef as ReactComponent };